import React, { useState } from 'react';

import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useAppSelector } from 'redux/hooks';
import { selectUserData } from 'redux/editProfile/userProfile.slices';
import useAuthentication from 'application/authentication/useAuthentication';
import LoadingUserAvatar from 'components/LoadingUserAvatar/LoadingUserAvatar';
import Edit from 'components/Icons/Edit';
import Web from 'components/Icons/Web';
import Exit from 'components/Icons/Exit';

import LanguageMenu from './components/LanguageMenu/LanguageMenu';

import './ProfileDrawer.scoped.scss';

interface Props {
  open?: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProfileDrawe: React.FC<Props> = ({ open, setOpen }) => {
  const [languageOpen, setLanguageOpen] = useState(false);
  const {
    t,
    i18n: { language: currentLanguageCode },
  } = useTranslation('login');
  const userData = useAppSelector(selectUserData);
  const { logOut } = useAuthentication();
  const currentLanguage = currentLanguageCode === 'en' ? 'English' : 'German';

  const role = t(
    {
      student: 'Student',
      teacher: 'Teacher',
    }[userData?.role] || 'Parent'
  );

  const handleLanguageClick = () => {
    setLanguageOpen(!languageOpen);
  };

  const handleMenuClose = () => {
    setOpen(false);
  };

  if (!userData) {
    return null;
  }

  return (
    <div className={classnames({ 'profile-drawer': true, open })}>
      <div className="item student">
        <div className="header">
          <div className="icon">
            <LoadingUserAvatar height={40} width={40} />
          </div>

          <div className="role-container">
            <div className="name">
              {userData?.first_name} {userData?.last_name}
            </div>
            <div className="role">{role}</div>
          </div>
        </div>
      </div>

      <div className="item edit-profile">
        <Link to="/edit-profile" className="header" onClick={handleMenuClose}>
          <div className="icon">
            <Edit fontSize={22} />
          </div>
          {t('Edit Profile')}
        </Link>
      </div>

      <div className={classnames({ item: true, language: true, open: languageOpen })}>
        <div className="header" onClick={handleLanguageClick}>
          <div className="icon">
            <Web fontSize={26} />
          </div>
          {t('Language')}
          <span className="light">({currentLanguage})</span>
          <div className="arrow"></div>
        </div>

        <LanguageMenu />
      </div>
      <div className="item sign-out" onClick={logOut}>
        <div className="header">
          <div className="icon">
            <Exit fontSize={22} />
          </div>
          {t('Sign out')}
        </div>
      </div>
    </div>
  );
};

export default ProfileDrawe;
